import { useQuery } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { Suspense, lazy, memo, useMemo } from 'react';

import type { HeaderOptions } from './model';
import { HeaderOptionsProvider } from './model';

import { getLibraryContentQuery } from '@shared/queries/common';
import type { MenuItem } from '@shared-types/menu.types';

const Header = lazy(() => import('./components/Header'));
const CompetitionHeader = lazy(() => import('./components/CompetitionHeader'));

export const App = ({ options, placeholder }: { options: HeaderOptions; placeholder?: ReactNode }) => {
  const { data: menu } = useQuery({
    ...getLibraryContentQuery<MenuItem[]>(options.libraryPath),
    enabled: !!options.libraryPath,
    placeholderData: [] as MenuItem[],
  });

  const headerOptions = useMemo(
    () => ({
      ...options,
      menu: options.menu ?? menu,
    }),
    [menu, options],
  );

  if (!headerOptions.menu?.length) return <>{placeholder}</>;

  return (
    <HeaderOptionsProvider options={headerOptions}>
      <Suspense>{options.isCompetitionContext ? <CompetitionHeader /> : <Header />}</Suspense>
    </HeaderOptionsProvider>
  );
};

export default memo(App);
